export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új template',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple"
                },
                sort: true,
                formVisible: false
            },
            {
                name: "deleted",
                label: "Státusz",
                sort: true,
                slot_name: "status_format",
                formVisible: false
            },
            {
                name: "emailBody",
                label: "E-mail szöveg",
                visibility: false,
                formVisible: true,
                formType: "text"
            },
            {
                name: "fileName",
                label: "Fájl név",
                visibility: false
            },
            {
                name: "key",
                label: "Kulcs",
                visibility: false
            },
            {
                name: "sizeKb",
                label: "Méret",
                visibility: false
            },
            {
                name: "type",
                label: "Típus",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
